import { Link } from "react-router-dom";
import { useAuth } from "../auth";

export function LandingPage() {
  const { status } = useAuth();
  const cta = status === "authed" ? "/app" : "/login";

  return (
    <div className="shell">
      <div className="noise" aria-hidden />
      <div className="aurora" aria-hidden />
      <div className="scanline" aria-hidden />

      <header className="top">
        <Link className="brand" to="/">
          BackupNode<small>echocord.ru</small>
        </Link>
        <nav>
          <Link to={cta}>{status === "authed" ? "Open chat" : "Access"}</Link>
          <a href="https://echocord.ru" rel="noopener">
            VPN
          </a>
        </nav>
      </header>

      <main className="hero">
        <div className="hero-copy">
          <p className="eyebrow">restricted · private llm</p>
          <h1 className="brand-hero">
            Backup<span>Node</span>
          </h1>
          <p className="lead">
            Локальные модели за WireGuard. Без публичного API в браузере — только свой вход.
          </p>
          <div className="status-row">
            <span className="status-plaque">
              <i className="status-dot" aria-hidden />
              <span>classified access</span>
            </span>
          </div>
          <div className="cta">
            <Link className="btn blood" to={cta}>
              {status === "authed" ? "Enter chat" : "Get access"}
            </Link>
            <a className="btn" href="https://echocord.ru">
              BackupNode VPN
            </a>
          </div>
        </div>
      </main>

      <footer className="foot">
        <span>BackupNode · EchoLLM</span>
        <span className="mono">chat.echocord.ru</span>
      </footer>
    </div>
  );
}
